import { getTakeoverVariantList } from 'modules/experiments/ducks/selectors';
import { useSelector } from 'react-redux';
import { LocalesContextProvider } from 'utils/contexts/locales/localeSettings';
import { LocalesQueryContextProvider } from 'utils/contexts/locales/templateAndProjectLocales';
import { LocaleSwitcherValidationContextProvider } from './LocaleSwitcherValidationContextProvider';
import { ValidationContextProvider } from './ValidationContextProvider';

export const VariantTemplateValidationContextProvider: React.FC<
  React.PropsWithChildren<unknown>
> = ({ children }) => {
  const variantList = useSelector(getTakeoverVariantList);
  // The default locale for the experiment will be the one set at the control.
  const controlVariantId = variantList.find(({ control }) => control)?.id ?? 0;

  return (
    <LocalesContextProvider>
      <LocalesQueryContextProvider templateId={controlVariantId}>
        <ValidationContextProvider controlVariantId={controlVariantId}>
          <LocaleSwitcherValidationContextProvider>
            {children}
          </LocaleSwitcherValidationContextProvider>
        </ValidationContextProvider>
      </LocalesQueryContextProvider>
    </LocalesContextProvider>
  );
};
